import React from 'react'
import t from 'prop-types'
import Offset from '../../Layouts/Offset'
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs'

import IconDownload from '../../Icons/IconDownload/IconDownload'

const PillarHeader = ({ head, chapters }) => {
  return (
    <div className="pillar-header -mt-20 md:-mt-40 mb-10 md:mb-16">
      <Offset direction="left">
        <div class="bg-gray-700 text-white">
          <Offset>
            <div className="max-w-screen-md mx-auto py-24 px-5">
              <div className="p">
                {head.crumbs && (
                  <Breadcrumbs crumbs={head.crumbs}></Breadcrumbs>
                )}
                <h1 className="font-serif font-bold text-white text-4xl lg:text-5xl leading-tight mt-10">
                  {head.title}
                </h1>

                {chapters && (
                  <div className="py-16">
                    <div className="text-xs md:text-sm lg:text-base leading-tight tracking-spacious font-medium uppercase">
                      {head.toc.label}
                    </div>

                    <ul className="mt-6">
                      {chapters.map((chapter, idx) => (
                        <li className="mt-7.5 first:mt-0">
                          <a
                            className="font-serif font-semibold text-blue-200 hover:text-blue-100 focus:text-blue-100 hover:underline text-xl lg:text-2xl leading-6 lg:leading-7.5"
                            href={chapter.href}
                          >
                            {chapter.label} {idx + 1}: {chapter.text}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {head.pdf?.link?.url && (
                  <div>
                    {head.pdf.label && (
                      <div className="text-xs md:text-sm lg:text-base leading-tight tracking-spacious font-medium uppercase">
                        {head.pdf.label}
                      </div>
                    )}
                    <div className="font-serif font-semibold text-white text-xl lg:text-2xl mt-6 block sm:flex">
                      {head.pdf.text && (
                        <span className="sm:mr-3">{head.pdf.text}</span>
                      )}

                      <a
                        href={head.pdf.link.url}
                        className="group mt sm:mt-0 flex"
                        target={
                          '_blank' === head.pdf.link.target ? '_blank' : '_self'
                        }
                      >
                        <span className="text-blue-200 group-hover:underline group-hover:text-blue-100 focus:text-blue-100 transition-colors ease-linear duration-200">
                          {head.pdf.link.title}
                        </span>
                        <div className="ml-3">
                          <IconDownload></IconDownload>
                        </div>
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Offset>
        </div>
      </Offset>
    </div>
  )
}

PillarHeader.propTypes = {
  head: t.object,
  chapters: t.array,
}

PillarHeader.defaultProps = {}

export default PillarHeader
